import { render, staticRenderFns } from "./fistipitanitim.vue?vue&type=template&id=5fab4056&"
import script from "./fistipitanitim.vue?vue&type=script&lang=js&"
export * from "./fistipitanitim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports